import type { ReactNode } from "react";
import { Menu } from "antd";
import { ArrowLeft2 } from "iconsax-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./SettingsLayout.css";

export interface SettingsTabItem {
  key: string;
  labelKey: string;
  path: string;
}

interface SettingsLayoutProps {
  titleKey: string;
  activeKey: string;
  tabs: SettingsTabItem[];
  children: ReactNode;
}

const SettingsLayout = ({ titleKey, activeKey, tabs, children }: SettingsLayoutProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="settings-layout">
      <div className="settings-layout__header">
        <button
          type="button"
          className="settings-layout__back"
          aria-label={t("back")}
          onClick={() => navigate(-1)}
        >
          <ArrowLeft2 size={20} color="currentColor" />
        </button>
        <h1 className="settings-layout__title">{t(titleKey)}</h1>
      </div>

      <div className="settings-layout__body">
        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          className="settings-layout__tabs"
          items={tabs.map((item) => ({
            key: item.key,
            label: t(item.labelKey),
          }))}
          onClick={({ key }) => {
            const target = tabs.find((item) => item.key === key);
            if (target) {
              navigate({
                pathname: target.path,
                search: location.search,
              });
            }
          }}
        />

        <div className="settings-layout__content">{children}</div>
      </div>
    </section>
  );
};

export default SettingsLayout;
